const initialState: any = {
    pending: false,
    success: false,
    error: false,
    data: null
}
  
export default initialState